import React, { Component, Fragment } from 'react';
import Loading from '../../../../flowtrace-components/Loading';
import { Card, CardContent, Button, Grid, Tooltip, Tabs, Tab, Paper } from '@material-ui/core';
import { Settings, Policy, Alarm, Translate, GetApp, Lock  } from '@material-ui/icons';
import accountAPI from '../../../../flowtrace-api/Account/propertyActions';
import MuiAlert from '@material-ui/lab/Alert';
import AppSettingsValidationRules from './appSettingsValidationRules';
import AppSettingStoreLinks from './appSettingStoreLinks';
import AppSettingsMeetingPolicy from './appSettingsMeetingPolicy';
import AppSettingsCostAlerting from './appSettingsCostAlerting';
import AppSettingsAuthentication from './appSettingsAuthentication';
import AppSettingsGeneral from './appSettingsGeneral';
import AppSettingsTranslation from './appSettingsTranslation';

const createAlert = (type, message, alertHeader = null, width, className) => {
  const maxWidth = { style: { maxWidth: width ? width : "600px" } };
  return (
    <MuiAlert key={"alertMessage" + message.replace(/\s+/g, '')} severity={type} className={className ? className : "pt-1 mt-1 mb-4 pb-1"}  {...maxWidth}>
      {alertHeader ? <span><strong className="d-block">{alertHeader}</strong><br/></span> : null}

      {message}
    </MuiAlert>
  );
};

const TabPanel = (props) => {
  const { children, value, index } = props;
  return (
    <Grid item xs={12} sm={12} hidden={value !== index} key={"tab-panel-" + index}>
      {children}
    </Grid>
  );
}

const appDefaultConfiguration = {
	enabled:true,
	buffer: 10, // Padding around meetings for 10 minutes
	tooltip:true, // Good for debugging
	showCurrency: true, // Time or Currency?
	show90day : true, // Recurring meeting cost estimates if available
	requireAuthentication: true, // Client can allow unauthenticated access based on Chrome profile to their account configuration
	alert: {
		enabled: true,
		type: "event", // event or recurring
		low: 60, // GREEN:
		medium: 180, // ORANGE: 3 people for 1 hour
		high: 480, // RED: 8 people for 1 hour
	},
	policy:{
		enabled:false,
		url: "https://hubs.ly/Q01-lv7T0",
		url_text:"Click for policy guide",
		header:"Flowtrace Meeting Policy",
		policy:[
			"Agenda must be sent 24h prior to meeting",
			"Meetings >10 hours trigger feedback automation",
			"Ask manager approval for >10 people meetings"
		]
	}
};

const parseAppSettings = (props) => {
  const account = props.flowtraceUser && props.flowtraceUser.account ? props.flowtraceUser.account : null;
  const chromeAPISettings = {
      authentication: {
          Value: { 
              account: account ? account.account_id : null,
              key: account && account.props && account.props.chromeExtensionAPIKey ? account.props.chromeExtensionAPIKey : null
          }
      }
  }
  const currentSettings = account && account.props && account.props.chromeExtension ? account.props.chromeExtension : {};
  const appSettings = {...appDefaultConfiguration, ...currentSettings};
  return { appSettings, chromeAPISettings, currentSettings };
}

class AppSettings extends Component {
  constructor(props) {
    super(props);
    const { chromeAPISettings, appSettings } = parseAppSettings(props);
    this.state = {loading:false, reload:false, tabIndex: 0, chromeAPISettings, appSettings, changed: this.props.onboarding ? true: false};
  }

  async updateSettings() {
    try{
      this.setState({loading:true});
      const { currentSettings } = parseAppSettings(this.props);
      // Remove existing properties before adding a new one
      if(currentSettings)
        await accountAPI.deleteProperty(this.props.flowtraceUser.account.account_id, {chromeExtension : currentSettings});
      const response = await accountAPI.addProperty(this.props.flowtraceUser.account.account_id, {chromeExtension:this.state.appSettings});
      if(response.success){
        await this.props.flowtraceUser.reload();
        return this.setState({changed:false, reload:true, loading:false});
      }
    } catch (e) {
      console.error(e);
    }
    return this.setState({error:"Something went wrong.", loading:false});
  }

  componentDidUpdate() {
    if(this.state.reload && !this.props.flowtraceUser.reloading){
      const { appSettings } = parseAppSettings(this.props);
      this.setState({reload:false, appSettings});
    }
  }
  componentWillUnmount() { this.setState = () => { return; }; };

  handleChange = (event) => {
    const clicked = event.target.name.split(".");
    const appSettings = this.state.appSettings;
    console.log("chasing handleChange", clicked)
    if(clicked.length === 3)
      appSettings[clicked[1]][clicked[2]] = event.target.checked;
    if(clicked.length === 2)
      appSettings[clicked[1]] = event.target.checked;
    this.setState({changed:true, appSettings});
  }
  updateValue = (event) => {
    const index = event.target.name.includes("|") ? event.target.name.split("|")[1] : null;
    const clicked = event.target.name.split(".");
    const appSettings = this.state.appSettings;
    if(clicked.length === 3 && index !== null)
      appSettings[clicked[1]][clicked[2].split("|")[0]][index] = event.target.value;
    else if(clicked.length === 3)
      appSettings[clicked[1]][clicked[2]] = event.target.value;
    else if(clicked.length === 2)
      appSettings[clicked[1]] = event.target.value;
    else
      return console.log("updateValue failed to parse the object path.", event.target.name, event.target.value);
    this.setState({changed:true, appSettings});
  }
  updateRules = (rules) => {
    console.log("chasing updateRules", rules)
    const appSettings = this.state.appSettings;
    appSettings.policy.rules = rules;
    this.setState({changed:true, appSettings});
  }
  updateTranslation = (language) => {
    const appSettings = this.state.appSettings;
    appSettings.language = language;
    this.setState({changed:true, appSettings});
  }

  updatePolicy = (policy) => {
    const appSettings = this.state.appSettings;
    appSettings.policy = policy;
    this.setState({changed:true, appSettings});
  }

  loading = () => <Loading text="Saving Meeting Cost for Calendar App settings."/>;
  reloading = () => <Loading text="Reloading account settings."/>;
  createHeader = (text, tooltip, component = null) => {
    if(component)
      return <Grid item xs={12} sm={12} md={12}>
        <h4 className="mt-2 mb-3 mr-5 font-weight-bold"><Tooltip title={tooltip}><span>{text}</span></Tooltip> {component}</h4>
      </Grid>;

    return <Grid item xs={12} sm={12} md={12}>
        <div className="font-weight-bold mr-3"><Tooltip title={tooltip}><span>{text}</span></Tooltip> </div>
    </Grid>;
  };
  
render() {
    if (this.state.loading)
      return this.loading();
    if (this.props.flowtraceUser.reloading)
      return this.reloading();

    const infoText = "We use caching to serve the configuration for you and your end users. It can take up to 60 minutes to see all the changes across the browsers and up to 24 hours to see them across all Outlook versions. You might need to refresh your Google Calendar browser page for your configuration.";
    const infoPlanUpgrade = "These settings are available only to paid Flowtrace plans. ";
    const infoTitle = "When do I see the settings updated in Google Calendar / Outlook?";
    const plan = this.props.flowtraceUser && this.props.flowtraceUser.account ? this.props.flowtraceUser.account.props.type : "free";
    const saveInfo = createAlert("info", (plan === "free" ? infoPlanUpgrade : "") + infoText, infoTitle, "100%", "mt-3");
    const saveButton = <Button disabled={!this.state.changed} onClick={async() => await this.updateSettings()} size="medium" variant="contained" color="primary" className="ml-1 mt-3 mr-3">Save Settings</Button>
  
    const loadingFunction = this.state.loading ? this.loading : this.props.flowtraceUser.reloading ? this.reloading : null;
    const minimumProps = {
      loading: loadingFunction, 
      settings: this.state.appSettings, 
      createHeader: this.createHeader,
      disabled: this.state.appSettings.disabled
    }
    const commonProps ={
      ...minimumProps,
      handleChange: this.handleChange, 
      updateValue: this.updateValue, 
    }
    const policyProps ={
      ...commonProps,
      updatePolicy: this.updatePolicy
    }
    const authenticationProps = {
      ...minimumProps,
      account: this.props.flowtraceUser.account,
      reload: this.props.flowtraceUser.reload
    }
    const validationProps = {
      ...minimumProps,
      rules: this.state.appSettings.policy.rules,
      updateRules : this.updateRules,
    }
    const translationProps = {
      ...minimumProps,
      updateTranslation: this.updateTranslation,
    }
    
    
    const generalTab = 
      <TabPanel value={this.state.tabIndex} index={0}>
        <AppSettingsGeneral {...commonProps} />
        <AppSettingsCostAlerting {...commonProps} />
      </TabPanel>
    const policyTab = 
      <TabPanel value={this.state.tabIndex} index={1}>
        <AppSettingsMeetingPolicy {...policyProps} />
      </TabPanel>
    const rulesTab = 
      <TabPanel value={this.state.tabIndex} index={2}>
        <AppSettingsValidationRules {...validationProps} />
      </TabPanel>
    const securityTab = 
    <TabPanel value={this.state.tabIndex} index={3}>
      <AppSettingsAuthentication {...authenticationProps} />
    </TabPanel>
    const translateTab = 
      <TabPanel value={this.state.tabIndex} index={4}>
        < AppSettingsTranslation {...translationProps} />
      </TabPanel>
    const installTab = 
      <TabPanel value={this.state.tabIndex} index={5}>
        <AppSettingStoreLinks {...minimumProps} />
      </TabPanel>
    const tabs = 
      <Paper square>
        <Tabs value={this.state.tabIndex} onChange={(_e, value) => this.setState({tabIndex:value})} variant="fullWidth" indicatorColor="secondary" textColor="secondary" >
          <Tab icon={<Settings />} label="Cost Configuration" />
          <Tab icon={<Policy />} label="Policy" />
          <Tab icon={<Alarm />} label="Rules" />
          <Tab icon={<Lock />} label="Security" />
          <Tab icon={<Translate />} label="Translation" />
          <Tab icon={<GetApp />} label="Install App" />
        </Tabs>
      </Paper>

    return (
      <Fragment>
        <Card className="card-box mb-4">
          <CardContent className="p-4">
            <Grid container spacing={3} direction="column" >
              <Grid item xs={12}>
                <h4 className="mb-3">Configure 'Meeting Cost for Google Calendar™ / Outlook™' App </h4>
              </Grid>
              <Grid item xs={12}>
                {tabs}
              </Grid>
              {generalTab}
              {policyTab}
              {rulesTab}
              {translateTab}
              {installTab}
              {securityTab}
              {this.state.tabIndex !== 3 ? 
                <Grid item xs={12} className="mt-3">
                  <Grid container spacing={3} alignItems="flex-end" direction="row" >
                    <Grid item xs={2} >
                      {saveButton}
                    </Grid>
                    <Grid item xs={10} >
                      {saveInfo}
                    </Grid>
                  </Grid>
                </Grid>
              : null }
            </Grid>
            </CardContent>
        </Card>
      </Fragment>
    );

  }
}

export default AppSettings;
